import React, { useContext } from "react";
import {
  Capture as CaptureComponent,
  Auth as MediastoreAuth,
} from "@cleeng/mediastore-sdk";
import { AuthContext } from "Context/AuthContext";

const Capture = (props) => {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

  React.useEffect(() => {
    MediastoreAuth.isLogged();
  }, [isAuthenticated]);
  return (
    <div>
      {MediastoreAuth.isLogged() ? (
        <>
          <h1>Capture</h1>
          <div id="Sub-Component-Capture">
            <CaptureComponent />
          </div>
        </>
      ) : (
        <>
          <h1>
            In order to see Capture component you need to be logged in.{" "}
            <br></br>Please login.
          </h1>
        </>
      )}
    </div>
  );
};

export default Capture;
